export default __webpack_public_path__ + "a2291dafb0ccea337c001f26029a3696.png";